import { render, staticRenderFns } from "./ChatImageViewer.vue?vue&type=template&id=b4c385f2&scoped=true"
import script from "./ChatImageViewer.vue?vue&type=script&lang=js"
export * from "./ChatImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ChatImageViewer.vue?vue&type=style&index=0&id=b4c385f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c385f2",
  null
  
)

export default component.exports